import React, { useEffect, useRef, useState } from 'react'
import { Column } from 'primereact/column'
import SexoService from "./sexoService"
import FormList from 'base/FormList'

export default function SexoList() {

    const [service] = useState(() => new SexoService())
    const toast = useRef(null)
    const searchData = {
        pkName: 'codigo_sexo',
        dsName: 'descricao_sexo',
        mainField: { name: 'descricao_sexo', label: 'Descrição' },
        advFields: [
            { name: 'codigo_sexo', label: 'Código', type: 'integer', inputMode: 'numeric' },
            { name: 'descricao_sexo', label: 'Descrição', type: 'string', inputMode: 'text' },
        ]
    }

    useEffect(() => {
    }, [service])

    return (
        <FormList service={service} toast={toast} searchData={searchData} showActions={true}>
            <Column field="descricao_sexo" sortable header="Descrição"></Column>
        </FormList >
    )
}
